export default {
  selection: "Pemilihan Bahasa Sistem",
  english: "English",
  simplified_chinese: "中文 （简体）",
  list: {
    en: "Inggris",
    zh: "Tionghoa (CN)",
    tw: "Tionghoa (TW)",
    vi: "Vietnam",
    th: "Thailand",
    id: "Indonesia",
    malay: "Melayu",
    jp: "Jepang",
    kr: "Korea",
    my: "Myanmar",
    ar: "Argentina",
    ru: "Rusia",
    ne: "Nepal",
    bn: "Bangla"
  }
};
